import { createContext, useContext, useMemo } from 'react';
import io, { Socket } from 'socket.io-client';

import config from '../config.json';

type SocketContextType = {
  socket: Socket;
};

export const SocketContext = createContext<SocketContextType | null>(null);

const SocketProvider = ({ children }: any) => {
  // teoricamente é o cliente do jogador atual...
  // entrou no modo online (mas não necessarimanete em uma sala)
  const socket = useMemo(() => io(config.socketUrl), []);

  return (
    <SocketContext.Provider
      value={{
        socket,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => {
  const context = useContext(SocketContext);

  if (!context)
    throw new Error('useSocket must be used within a SocketProvider');

  const { socket } = context;

  return socket;
};

export default SocketProvider;
